<template lang="pug">
  div
    div.label.basic600--text.text-uppercase.mb-2 Tier
    //- All
    v-chip.button-AA-tiny.text-uppercase.mr-2(label small :outlined="!selectedTier" :color="!selectedTier ? 'info500' : 'basic300'" :style="!selectedTier ? `background-color: ${$vuetify.theme.themes[$theme].infoT08} !important` : ''" @click="selectedTier = null") All
    template(v-for="tier in companyTiers")
      v-chip.button-AA-tiny.text-uppercase.mr-2(label small :outlined="tier.id === selectedTier" :color="tier.id === selectedTier ? 'info500' : 'basic300'" :style="tier.id === selectedTier ? `background-color: ${$vuetify.theme.themes[$theme].infoT08} !important` : ''" @click="selectedTier = tier.id") {{ tier.name }}
</template>

<script>
export default {
  name: 'PayoutTier',
  props: {
    companyTiers: {
      type: Array,
      required: true
    },
    parentTier: {
      type: Number,
      default: null
    },
  },
  computed: {
    selectedTier: {
      get () {
        return this.parentTier
      },
      set (newValue) {
        this.$emit('update:parentTier', newValue)
      }
    },
  }
}
</script>